module.exports = __webpack_public_path__ + "static/media/icon_aws-athena.9938ba7b.svg";